import {
  GET_CAMPAIGN_STICKY_COLUMNS,
  GET_CAMPAIGN_STICKY_COLUMNS_SUCCESS,
  GET_CAMPAIGN_STICKY_COLUMNS_ERROR,
  UPDATE_CAMPAIGN_STICKY_COLUMNS,
  UPDATE_CAMPAIGN_STICKY_COLUMNS_SUCCESS,
  UPDATE_CAMPAIGN_STICKY_COLUMNS_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  user_column_preference_campaign: null,
  loading: false
}

const UserCampaignColumnPreference = (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGN_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case GET_CAMPAIGN_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_campaign: action.payload,
        loading: false
      }

    case GET_CAMPAIGN_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_CAMPAIGN_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_CAMPAIGN_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_campaign: action.payload,
        loading: false
      }

    case UPDATE_CAMPAIGN_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}

export default UserCampaignColumnPreference;
